import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/tax_offices`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/tax_offices/${id}`, options)
        .then(response => {
            let taxOffice = jsona.deserialize(response.data);
            delete taxOffice.links;
            return taxOffice;
        });
}

function add(taxOffice) {

    const payload = jsona.serialize({
        stuff: taxOffice,
        includeNames: ['categories']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/tax_offices`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(taxOffice) {
    const payload = jsona.serialize({
        stuff: taxOffice,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/tax_offices/${taxOffice.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/tax_offices/${id}`, options);
}

export default {
    list,
    get,
    add,
    update,
    destroy
};